import styled, { keyframes } from "styled-components";
import { colors } from "../../../../styles/colors";

// Animation keyframes
const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const slideInFromBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const bounceIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.3) translateY(-20px);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) translateY(-5px);
  }
  70% {
    transform: scale(0.95) translateY(0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

const tooltipSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -100%) scale(0.8) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -100%) scale(1) translateY(0);
  }
`;

export const ChartContainer = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  animation: ${slideInFromBottom} 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: transform 0.3s ease, filter 0.3s ease;

  &:hover {
    transform: scale(1.05);
    filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.1));
  }

  /* Remove outline from pie chart sectors */
  .recharts-layer,
  .recharts-pie-sector {
    outline: none !important;
    &:focus {
      outline: none !important;
    }
    &:active {
      outline: none !important;
    }
  }

  /* Remove outline from SVG elements */
  svg {
    outline: none !important;
    &:focus {
      outline: none !important;
    }
    &:active {
      outline: none !important;
    }
  }

  /* Remove outline from all child elements */
  * {
    outline: none !important;
    &:focus {
      outline: none !important;
    }
    &:active {
      outline: none !important;
    }
  }
`;

export const TooltipImage = styled.img`
  width: 60px;
  height: 65px;
  animation: ${bounceIn} 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transition: transform 0.2s ease;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  &:hover {
    transform: scale(1.1);
  }
`;

export const TooltipContent = styled.div`
  position: absolute;
  width: 55px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  line-height: 1.2;
  animation: ${fadeInScale} 0.4s ease-out 0.2s both;
  z-index: 2;
  pointer-events: none;
`;

export const CustomTooltipContainer = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  left: ${(props) => props.$x}px;
  top: ${(props) => props.$y}px;
  transform: translate(-50%, -100%);
  animation: ${tooltipSlideIn} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.2));
  z-index: 1000;
  pointer-events: none;
  transition: all 0.2s ease;
  width: 60px;
  height: 65px;
`;

export const TooltipTitle = styled.div`
  color: ${colors.blueGray};
  font-size: 7px;
  text-align: center;
  margin-bottom: 2px;
  animation: ${fadeInScale} 0.3s ease-out 0.3s both;
  transition: color 0.2s ease;
  padding-top: 10px;
`;

export const TooltipValue = styled.div`
  color: ${colors.darkBlue};
  font-size: 14px;
  text-align: center;
  font-weight: 600;
  animation: ${fadeInScale} 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.4s
    both;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;
